<template>
  <div>
    <box-info :class="{ 'suggested-plan': chosenPlan.suggested }" class="ls-xs-margin-bottom ls-display-none-xs">
      <div slot="suggested" v-if="chosenPlan.suggested" class="ribbon ribbon-top-right"><span>{{ $t('subscribe.attributes.suggested') }}</span></div>
      <h6 class="ls-text-xl" slot="title">{{ chosenPlan.name }}</h6>
      <h3 slot="value">R$ <span>{{ money.parseViewValue(chosenPlan.price) }}</span><small>/ {{ $t('subscribe.attributes.monthly') }}</small></h3>
      <p slot="description" class="plan-description">{{ chosenPlan.description }}</p>
      <footer slot="footer" class="ls-box-footer">
        <div v-if="formsSubmitted">
          <button type="button" class="btn ls-full-width ls-text-lg" @click="checkout" :class="{ 'btn-act is-active' : formsSubmitted }">{{ $t('subscribe.buttons.hire') }}</button>
        </div>
      </footer>
    </box-info>
    <p class="ls-text-sm ls-display-none-xs"><a href="javascript:void(0)" @click.prevent="$parent.backToSignaturePlans"><i class="fa fa-arrow-left" aria-hidden="true"></i> {{ $t('subscribe.attributes.choose_another_plan') }}</a></p>
    <button type="button" class="btn btn-act next btn-fixed-bottom-xs ls-display-none-sm ls-display-none-md ls-display-none-lg" @click="checkout" v-if="formsSubmitted">{{ $t('subscribe.buttons.hire') }} <span><i class="fa fa-check" aria-hidden="true"></i></span></button>
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import BoxInfo from './BoxInfo.vue'
  import money from 'src/utils/money'
  import scroll from 'src/utils/scroll'

  export default {
    name: 'Checkout',
    components: { BoxInfo },
    data () {
      return {
        onlyNumber: /[\D]/g,
        disabled: false,
        money: money,
        showPlan: false,
        messageAlert: false,
        parsedCust: {}
      }
    },
    computed: {
      ...mapGetters(['chosenPlan', 'basicSeller', 'contract', 'cust']),
      formsSubmitted () {
        return this.$parent.$data.forms.submitted.signup
      }
    },
    methods: {
      ...mapActions(['createCustomer', 'editCustomer', 'createContract', 'createInvoice']),
      ...mapMutations(['clearFlash', 'addFlash']),
      showPlanDetails () {
        this.showPlan = !this.showPlan
      },
      checkout () {
        this.$loader.show()
        this.clearFlash()
        if (this.formsSubmitted) {
          let params = { seller_id: this.basicSeller.id, contract: { day_expiration: this.currentDay(), plans: [{ code: this.chosenPlan.code }] }, seller_code: JSON.parse(window.localStorage.basicSeller).code, customer_id: this.cust.id }
          this.$store.state.auth.customerToken = window.localStorage.customerToken
          this.createContract(params).then(this.afterCreateContract)
        } else {
          this.$loader.hide()
          this.addFlash({ message: this.$t('subscribe.messages.before_next_step'), type: 'ls-alert-danger' })
          scroll.scrollToFlash()
        }
      },
      afterCreateContract (response) {
        this.$loader.hide()
        if (response.status === 201) {
          this.$router.push({ name: 'payment', params: { id: response.data.contract.invoices[0].id } })
          window.localStorage.removeItem('customer')
          window.localStorage.removeItem('customerToken')
        }
      },
      currentDay () {
        return new Date().getDate()
      }
    }
  }
</script>
<style lang="scss" scoped>
  .change-plan {
    display: block;
    text-decoration: underline;
    position: relative;
    font-weight: 100;
    color: #e2e2e2;
  }
  .finish-checkout {
    background: #494d58;
    color: white;
    display: block;
    transition: all 0.5s ease;
    position: fixed;
    z-index: 999;
    bottom: 0;
    left: 0;
    padding: 20px;
    // opacity: 0.9;
    width: 100%;
    .chosen-plan {
      display: inline-block;
      max-width: 186px;
    }
    .change-plan {
      display: block;
      text-decoration: underline;
      position: relative;
      font-weight: 100;
      color: #e2e2e2;
    }
  }
  .is-active {
    border-bottom: 4px solid #1e8a4b;
    box-shadow: inset 0px 0px 4px rgba(0,0,0,0.15);
    top: -2px;
  }
</style>



// WEBPACK FOOTER //
// BoxCheckout.vue?41e53cba